import { render, staticRenderFns } from "./CrmSalonHome.vue?vue&type=template&id=5d560cd2&"
import script from "./CrmSalonHome.vue?vue&type=script&lang=js&"
export * from "./CrmSalonHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports